import React from 'react';
import withState from '../../../../../utils/withState';
import List from './List';
import Edit from './Edit';
import {
  cryptoAccountId$,
} from './state';


module.exports = withState(() => {
  return (state, props) => {
    const View = state.cryptoAccountId$ ? Edit : List;

    return (
      <View {...props}/>
    );
  };
}, {
  cryptoAccountId$: cryptoAccountId$,
});
